module.exports = __webpack_public_path__ + "static/media/Colette Stripe Super King Headboard - 200 cm_Dark Brown.a255f11c.png";